import { createSelector } from 'reselect'
import * as SelectorUtils from './utils'
import { DefaultState } from '../reducers/DefaultState'

export const DefaultAudienceAcquisitionDetailsState = {
  ...DefaultState
}

const getAudienceAcquisitionTopicId = (state, props) => {
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return topicId
}

const getAudienceAcquisitionByIdState = (state, props) => {
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return state.audienceAcquisition.byId[topicId]
}

const getAudienceAcquisitionTopicDetailsState = createSelector(
  [getAudienceAcquisitionByIdState],
  (state) => {
    return (state || {}).audienceAcquisition || DefaultAudienceAcquisitionDetailsState
  }
)

const makeAudienceAcquisitionTopicIdSelector = () => {
  return createSelector(
    [getAudienceAcquisitionTopicId],
    topicId => {
      return topicId
    }
  )
}

const makeAudienceAcquisitionTopicSelector = () => {
  return createSelector(
    [getAudienceAcquisitionTopicDetailsState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

export {
  makeAudienceAcquisitionTopicIdSelector,
  makeAudienceAcquisitionTopicSelector
}
